import React from 'react';
import {
  ApiOutlined,
  GroupOutlined,
  ImportOutlined,
  ReconciliationOutlined,
  SettingOutlined,
  UploadOutlined,
} from '@ant-design/icons';

import { buildingsDisplayName } from '@totem/components/ui_components/constants';
import { getMenuAdminAccount } from '@totem/components/ui_components/menus/mainMenu/admin_account';
import { getMenuAdminAPIs } from '@totem/components/ui_components/menus/mainMenu/admin_apis';
import { getMenuAdminConfiguration } from '@totem/components/ui_components/menus/mainMenu/admin_configuration';
import { getMenuAdminDataManagement } from '@totem/components/ui_components/menus/mainMenu/admin_dataMgmt';
import { getMenuAdminLogManagement } from '@totem/components/ui_components/menus/mainMenu/admin_logManagement';
import { getMenuAdminMappings } from '@totem/components/ui_components/menus/mainMenu/admin_mappings';
import { IBMenuItem } from '@totem/components/ui_components/menus/types';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { UserProfile } from '@totem/types/user';
import { getMenuAdminDataHygiene } from '@totem/components/ui_components/menus/mainMenu/admin_dataHygiene';

export const getSubMenuAdmin = (userProfile: UserProfile) => {
  const items: IBMenuItem[] = [
    {
      key: 'account',
      title: 'Account',
      label: 'Account',
      description: 'Account Details',
      //route: '/dashboard/settings',
      icon: <SettingOutlined />,
      hasPermissions: () => {
        return getMenuAdminAccount(userProfile).length > 0;
      },
      children: getMenuAdminAccount(userProfile),
    },
    {
      key: 'softwareImport',
      title: 'Software Import',
      label: 'Software Import',
      description: 'Import devices and installed software from a CSV report',
      route: '/dashboard/devices/software/import',
      icon: <UploadOutlined />,
      hasPermissions: () => {
        return (
          permissions.softwareReporting.hasPermissions(userProfile) &&
          permissions.organizationalAdministrator.hasPermissions(userProfile)
        );
      },
    },
    {
      key: 'socommissioning',
      title: 'Commissioning',
      label: 'Commissioning',
      description: 'Commissioning Report',
      route: '/dashboard/admin/salesOrderCommissioning',
      icon: <GroupOutlined />,
      hasPermissions: () => {
        return permissions.internalOrganizationalAdministrator.hasPermissions(
          userProfile,
        );
      },
    },
    {
      key: 'apiManagement',
      title: 'API Management',
      label: 'API Management',
      description: 'API Management',
      //route: '/dashboard/admin/apiManagement',
      children: getMenuAdminAPIs(userProfile),
      icon: <ApiOutlined />,
      hasPermissions: () => {
        return getMenuAdminAPIs(userProfile).length > 0;
      },
    },
    {
      key: 'configurationManagementr',
      title: 'Configuration',
      label: 'Configuration',
      description: 'Configuration Management',
      //route: '/dashboard/admin/configuration',
      children: getMenuAdminConfiguration(userProfile),
      icon: <ImportOutlined />,
      hasPermissions: () => {
        return getMenuAdminConfiguration(userProfile).length > 0;
      },
    },
    {
      key: 'dataManagement',
      title: 'Data Management',
      label: 'Data Management',
      description: 'Data Management',
      //route: '/dashboard/admin/dataManagement',
      children: getMenuAdminDataManagement(userProfile),
      icon: <ImportOutlined />,
      hasPermissions: () => {
        return getMenuAdminDataManagement(userProfile).length > 0;
      },
    },
    {
      key: 'dataHygiene',
      title: 'Data Hygiene',
      label: 'Data Hygiene',
      description: 'Data Hygiene',
      children: getMenuAdminDataHygiene(userProfile),
      icon: <ImportOutlined />,
      hasPermissions: () => {
        return getMenuAdminDataHygiene(userProfile).length > 0;
      },
    },
    {
      key: 'logManagement',
      title: 'Log Management',
      label: 'Log Management',
      description: 'Log Management',
      //route: '/dashboard/admin/logManagement',
      children: getMenuAdminLogManagement(userProfile),
      icon: <ImportOutlined />,
      hasPermissions: () => {
        return getMenuAdminLogManagement(userProfile).length > 0;
      },
    },
    {
      key: 'mappings',
      title: 'Mappings',
      label: 'Mappings',
      description: `Tool Mappings (Tenants -> ${buildingsDisplayName})`,
      //route: '/dashboard/admin/mappingManagement',
      children: getMenuAdminMappings(userProfile),
      icon: <ImportOutlined />,
      hasPermissions: () => {
        return getMenuAdminMappings(userProfile).length > 0;
      },
    },
    {
      key: 'cyberReportPage',
      title: 'Cyber Review',
      label: 'Cyber Review',
      description: 'Cyber Security Report',
      route: '/dashboard/cyberReportPage',
      icon: <ReconciliationOutlined />,
      hasPermissions: () => {
        return (
          permissions.internalSystemAdministratorIBOrg.hasPermissions(
            userProfile,
          ) && userProfile.email.startsWith('shannon.smith')
        );
      },
    },
  ];

  return items.filter((chk) => chk.hasPermissions(userProfile));
};
